import { Modal } from 'react-async-popup';
import '../ui/emergencyPopup.css';
import ticketService from '../../ticketService';
import TicketUpdateError from './TicketUpdateError';
import LaunchOffer from './LaunchOffer';
import { mutate } from 'swr';

const useLaunchOfferModal = (ticket, type) => {
  // open modal
  const launchOffer = async () => {
    const { show } = await Modal.new({
      content: <LaunchOffer ticket={ticket} type={type} />,
      footer: null,
      wrapClassName: 'launch',
    });
    const result = await show();
    return result;
  };

  return () => {
    return launchOffer()
      .then((result) => {
        if (!result) throw Error('Skip');
        return result;
      })
      .then(async (dto) => {
        const lastRoute = ticket.cargo.routes[ticket.cargo.routes.length - 1];
        const routeId = lastRoute.id;
        const backendResult = ticketService.callBackend.launchOffer({ routeId, dto });
        mutate((key) => {
          return typeof key === 'string' && key.startsWith('tickets');
        });
        return backendResult;
      })
      .catch((err) => {
        if (err.message !== 'Skip') throw err;
      })
      .catch((err) => {
        if (isNaN(err.code)) throw err;

        return Modal.new({
          content: <TicketUpdateError ticket={ticket} type={type} />,
          footer: null,
        }).then(({ show }) => show());
      });
  };
};

export default useLaunchOfferModal;
